import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useLocation } from "react-router-dom";

import { sidebarMenu } from "../config/sidebarMenu";

/** Flat menu config -> sections with their pages. Empty ones drop out. */
export const buildNavGroups = (itemVisible) => {
  const groups = [];
  let current = null;

  for (const entry of sidebarMenu) {
    if (entry.type === "group") {
      current = { label: entry.label, items: [] };
      groups.push(current);
      continue;
    }
    if (entry.type === "item" && entry.to && itemVisible(entry)) {
      if (!current) groups.push({ label: entry.label, items: [entry] });
      else current.items.push(entry);
    }
  }
  return groups.filter((g) => g.items.length > 0);
};

/**
 * `end` exists for the index route: "/" is a prefix of every other path, so
 * without it the overview stays lit on every page in the panel.
 */
const isItemActive = (pathname, item) =>
  item.end
    ? pathname === item.to
    : pathname === item.to || pathname.startsWith(`${item.to}/`);

/**
 * The rail.
 *
 * The design this panel comes from navigates from a two-row top bar; this one
 * navigates from a rail, which is the single structural difference between
 * them. It reads the same config that bar did, so a section is added in one
 * place.
 *
 * `compact` is the icon-only rail (2026-10-22): labels go, each link names
 * itself in a hover tip (`data-tip`) and to screen readers (`aria-label`),
 * and a section title shrinks to a hairline so the groups still read apart.
 */
const Rail = ({ itemVisible, onNavigate, compact = false }) => {
  const location = useLocation();
  const groups = buildNavGroups(itemVisible);

  return (
    <nav className="ms-rail-nav" aria-label="Boʻlimlar">
      {groups.map((group) => (
        <div className="ms-rail-group" key={group.label}>
          {/* A div, not a heading: these name a run of links inside a nav, so
              they are not landmarks in the page's outline. */}
          <div className="ms-rail-group-title" aria-hidden={compact || undefined}>
            {group.label}
          </div>
          {group.items.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={onNavigate}
              aria-label={compact ? item.label : undefined}
              data-tip={compact ? item.label : undefined}
              className={`ms-rail-link ${
                isItemActive(location.pathname, item) ? "is-active" : ""
              }`.trim()}
            >
              <Icon icon={item.icon} className="ms-rail-link-icon" />
              <span>{item.label}</span>
            </Link>
          ))}
        </div>
      ))}
    </nav>
  );
};

export default Rail;
